"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon64Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon64Regular = forwardRef_1.forwardRef('SearchLoupeIcon64Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 64 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30 6C16.745 6 6 16.745 6 30s10.745 24 24 24a23.909 23.909 0 0 0 15.877-6.002l11.062 11.063a1.5 1.5 0 0 0 2.122-2.122L47.998 45.877A23.909 23.909 0 0 0 54 30C54 16.745 43.255 6 30 6ZM9 30C9 18.402 18.402 9 30 9s21 9.402 21 21-9.402 21-21 21S9 41.598 9 30Z" })));
});
